import React from 'react';
import _ from 'lodash';
import { Box, Grid, Typography } from "@mui/material";
import PasswordConfiguration from './components/PasswordConfiguration';
import AgreementsSection from './components/AgreementsSection';
import SupportFooter from './components/SupportFooter';
import DocumentTitle from 'react-document-title'
import Header from './components/Header';
import { getProgramTitle } from 'utils/utils.js'
import Button from 'components/CustomButtons/Button.jsx'
import EmailFieldConfig from './components/EmailFieldConfig';
import SnackDefault from 'components/SnackDefault'
import Loader from 'components/Loader/Loader.jsx'
import { SuccessModal } from './components/SuccessModal';

export default function TemplatePage({ ...sharedProps }) {
  const { t, handleSubmit, onSubmit, errors, contact, sucess, themeColor, closeSnack, snackStatus, history, loading } = sharedProps;
  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} autoComplete="off" height="100vh" overflow="hidden">
      <SnackDefault
        snackStatus={snackStatus}
        handleCloseSnack={() => closeSnack()}
      />
      {sucess && (
        <SuccessModal
          open={sucess}
          themeColor={themeColor}
          handleClose={() => history.push('/auth/login')}
        />
      )}
      {loading && <Loader />}
      <Grid container height={'100%'}>
        <Grid item md={8} xs={12} sm={12} sx={{ overflowY: 'auto', height: '100vh' }}>
          <DocumentTitle title={getProgramTitle(t('TITLE_REGISTER'))} />
          <Header {...sharedProps} />
          <Grid item container xs={12} justifyContent="center">
            <Box width="100%" maxWidth="800px" display="flex" flexDirection="column" gap="30px" mt="30px" alignItems={'center'}>
              <Typography variant="body1" color="#5D5D5D" textAlign="center" mt>
                Para aproveitar <b>todos</b> os recursos do programa, <br />
                defina sua senha e complete seus dados no cadastro. É rápido.
              </Typography>
              <PasswordConfiguration {...sharedProps} />
              <EmailFieldConfig {...sharedProps} />
              <AgreementsSection {...sharedProps} />
              <Box display="flex" justifyContent="center" pb="20px" width="100%" >
                <Button
                  size="sm"
                  fullWidth
                  variant="contained"
                  style={{
                    maxWidth: '420px',
                    backgroundColor: !_.isEmpty(errors)
                      ? 'gray'
                      : themeColor
                        ?.navigation?.buttons
                        ?.backgroundColor,
                  }}
                  disabled={!_.isEmpty(errors)}
                  type="submit"
                >
                  Cadastrar
                </Button>
              </Box>
            </Box>
          </Grid>

        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Box height="100vh" overflow="hidden">
            <SupportFooter t={t} contact={contact} />
          </Box>
        </Grid>
      </Grid >

    </Box >
  );
}
